export default function DataTableIcon(props) {
  return (
    <svg {...props} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM4.16667 6.9375H15.8333V4.16667H4.16667V6.9375ZM4.16667 11.3958H15.8333V8.60417H4.16667V11.3958ZM4.16667 15.8333H15.8333V13.0625H4.16667V15.8333ZM5 6.375V4.70833H6.66667V6.375H5ZM5 10.8333V9.16667H6.66667V10.8333H5ZM5 15.2917V13.625H6.66667V15.2917H5Z"
        fill="currentColor"
      />
    </svg>
  );
}
